import { useCallback, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { Element } from '../../../../../../common/html/element'
import { debounce } from '../../../../../../helpers/common'
import { CustomDropdown } from '../../../../common/customDropdown'
import { ListSelectable } from '../../../../common/listSelectable'
import { getSuggestData } from '../../../store/thunk'
import { positionDropdown } from './../../../../../../common/dropdown/index'
import classes from './index.module.scss'

export const TextBoxSuggestion = ({
  renderInput,
  suggestionLink,
  keyword,
  onChoose,
}) => {
  const dispatch = useDispatch()

  const [suggestData, setSuggestData] = useState([])

  const handleGetSuggestData = useCallback(
    debounce((keyword) => {
      if (!keyword) {
        setSuggestData([])
        return
      }
      dispatch(
        getSuggestData({
          path: suggestionLink,
          params: { Term: keyword },
        }),
      )
        .unwrap()
        .then((data) => {
          setSuggestData(data.filter(Boolean))
        })
    }, 500),
    [],
  )

  useEffect(() => {
    handleGetSuggestData(keyword?.trim())
  }, [keyword])

  const renderDropdown = ({ hideDropdown, position }) => {
    return (
      <ListSelectable
        data={suggestData}
        renderItem={(item, { isActive }) => (
          <Element
            className={classes.suggestItem}
            style={{
              borderColor: '#E5E5E5',
              backgroundColor: isActive ? '#C8E3FF' : '',
            }}
          >
            {item}
          </Element>
        )}
        onChoose={(value) => {
          onChoose(value)
          hideDropdown()
        }}
        onChooseOutSide={hideDropdown}
        startIndex={
          position === positionDropdown.TOP_START_RIGHT
            ? suggestData.length
            : -1
        }
      />
    )
  }

  return (
    <CustomDropdown
      renderElement={renderInput}
      renderDropdown={renderDropdown}
      allowShowDropdown={!!suggestData.length}
      wrapperClassname="w100"
      dropdownItemHeight={26}
      maxDropdownItem={Math.min(suggestData.length, 10)}
      dropdownStyle={{ padding: 0, backgroundColor: '#F3F3F3' }}
    />
  )
}
